import { z } from 'zod';
import { u32 } from './current-project';
import { utf8Length } from '@/lib/auth-validation';

export const skillRequestPayloadSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, 'Enter a skill name.')
      .refine(
        (name) => utf8Length(name) <= 100,
        'Skill names must fit within 100 UTF-8 bytes.'
      ),
    roleIds: z
      .array(u32.min(1))
      .min(1, 'Select at least one related role.')
      .refine(
        (ids) => new Set(ids).size === ids.length,
        'Related roles must be unique.'
      ),
  })
  .strict();
export const skillRequestViewSchema = skillRequestPayloadSchema
  .extend({
    requestId: z.string().regex(/^0x[0-9a-f]{32}$/),
    requester: z.string().regex(/^0x[0-9a-f]{64}$/),
    status: z.enum(['Pending', 'Approved', 'Rejected']),
    skillId: u32.min(1).nullable(),
  })
  .refine(
    (request) => (request.status === 'Approved') === (request.skillId !== null),
    'Only approved requests have a catalog skill ID.'
  );
